// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__22R7F","header":"ReportDetails_header__2z5V7","title":"ReportDetails_title__1Isyz","left":"ReportDetails_left__26iqK"};